export class AbsctractValidator {
    constructor(input) {
        this.input = input;
        this.isValid = this.isValid.bind(this);
        this.message = this.message.bind(this);
        this.setInput = this.setInput.bind(this);
    }

    isValid() {
        return false;
    };

    message() {
        return "Error";
    };
    setInput(input) {
        this.input = input ? input : undefined;
    }
}


// WEBPACK FOOTER //
// ./src/validator/AbstractValidator.js